import isEmpty from 'lodash/isEmpty';

export const CLIA_PRACTICES = [
  'Ambulance',
  'Ancillary Testing Site in Health Care Facility',
  'Assisted Living Facility',
  'Behavioral Health Clinic',
  'Blood Bank',
  'Clinical Lab',
  'Community Clinic',
  'Comp. Outpatient Rehab Facility',
  'Drug and Alcohol Rehabilitation Center',
  'End Stage Renal Disease Dialysis Facility',
  'Federally Qualified Health Center',
  'Health Center',
  'Health Main. Organization',
  'Home Health Agency',
  'Hospice',
  'Hospital',
  'Independent',
  'Industrial',
  'Insurance',
  'Intermediate Care Facilities for Individuals with Intellectual Disabilities',
  'Mental Health/Chemical Dependency Facility',
  'Mobile Laboratory',
  'Pathology',
  'Pharmacy',
  'Physician Office',
  'Practitioner Other',
  'Prison',
  'Public Health Laboratories',
  'Rural Health Clinic',
  'School/Student Health Service',
  'Skilled Nursing Facility/ Nursing Facility',
  'Tissue Bank/Repositories',
];

export const getSubmitRequestObj = (request) => {
  const w9Details = request.w9Form
    ? {
        name: request.w9Form.name,
        businessName: request.w9Form.businessName,
        federalTaxClassification: request.w9Form.federalTaxClassification,
        doc360Id: request.documentIds['w9form.fileName'],
      }
    : null;
  const isClia = CLIA_PRACTICES.includes(
    request.practiceInfo.practiceTypeSelection
  );
  const isAsc =
    request.practiceInfo.practiceTypeSelection === 'Ambulatory Surgery Center';

  const licenses = request.practiceInfo.medLicense;
  const medLicense = [];

  if (licenses && licenses.length) {
    licenses.map((med) => {
      if (med.licenseType || med.licenseNumber) {
        medLicense.push({
          licenseType: med.licenseType,
          licenseNumber: med.licenseNumber,
          state: med.state ? med.state : '',
        });
        return true;
      }
      return false;
    });
  }

  const practiceInformation = request.practiceInfo
    ? {
        registrationType: request.practiceInfo.registrationTypeSelection,
        practiceType: request.practiceInfo.practiceTypeSelection,
        cliaId: isClia ? request.practiceInfo.cliaIdentification : '',
        medicareId: isAsc ? request.practiceInfo.medicareId : '',
        doc360IdCms: isClia
          ? request.documentIds['practiceInformation.cliaFile']
          : '',
        isRevoked: request.practiceInfo.restrictionSelection === 'Yes',
        additionalDetails:
          request.practiceInfo.restrictionSelection === 'Yes'
            ? request.practiceInfo.restrictionInput
            : null,
        npi: [...request.practiceInfo.npiInformation.split(',')],
        isNpiValid: request.practiceInfo.isNpiValid,
        licenses: medLicense,
      }
    : null;
  const address = request.address
    ? [
        {
          streetLine1: request.address.primaryServicing.streetLine1,
          streetLine2: request.address.primaryServicing.streetLine2,
          city: request.address.primaryServicing.city,
          state: request.address.primaryServicing.state,
          zipCode: request.address.primaryServicing.zipCode,
          type: 'PrimaryService',
          doc360Id: request.documentIds['address.primaryServicingProof'],
        },
        {
          streetLine1: request.address.primaryBilling.streetLine1,
          streetLine2: request.address.primaryBilling.streetLine2,
          city: request.address.primaryBilling.city,
          state: request.address.primaryBilling.state,
          zipCode: request.address.primaryBilling.zipCode,
          type: 'PrimaryBilling',
          doc360Id: request.documentIds['address.primaryBillingProof'],
        },
        {
          streetLine1: request.address.primaryRemittance.streetLine1,
          streetLine2: request.address.primaryRemittance.streetLine2,
          city: request.address.primaryRemittance.city,
          state: request.address.primaryRemittance.state,
          zipCode: request.address.primaryRemittance.zipCode,
          type: 'PrimaryRemit',
          doc360Id: request.documentIds['address.primaryRemittanceProof'],
        },
      ]
    : [];
  if (
    request.address &&
    request.address.secondaryServicing &&
    request.address.secondaryServicing[0] != null &&
    request.address.secondaryServicing.length > 0
  ) {
    const addressList = request.address.secondaryServicing;

    addressList.map((add, index) => {
      if (add) {
        address.push({
          streetLine1: add.streetLine1,
          streetLine2: add.streetLine2,
          city: add.city,
          state: add.state,
          zipCode: add.zipCode,
          type: `SecondaryService${index + 1}`,
          doc360Id:
            request.documentIds[`address.secondaryServicing[${index}].proof`],
        });
        return true;
      }
      return false;
    });
  }
  let claimDateCheck = null;

  if (request.attestation) {
    claimDateCheck = request.attestation.claimDate
      ? String(request.attestation.claimDate).replaceAll('/', '-')
      : request.attestation.claimDate;
  }

  const attestationDetails = request.attestation
    ? {
        name: request.attestation.submitterName,
        phoneNumber: request.attestation.phoneNumber,
        jobTitle: request.attestation.jobTitle,
        email: request.attestation.emailAddress,
        communicationPreference: request.attestation.commPreference,
        aarpCoverage: request.aarpToggle
          ? request.attestation.healthProgram
          : null,
        isAarpCovered: request.aarpToggle
          ? !!(
              request.attestation.healthProgram &&
              (request.attestation.healthProgram === 'aarp' ||
                request.attestation.healthProgram === 'uhc')
            )
          : null,
        claimDate:
          request.attestation.submitClaim === 'Yes' ? claimDateCheck : null,
        doc360Id:
          request.signatureType === 'Text'
            ? request.documentIds.textSignature
            : request.documentIds.drawSignature,
        isClaimSubmitted: request.attestation.submitClaim === 'Yes',
      }
    : {};
  return { w9Details, practiceInformation, address, attestationDetails };
};

export const getFileType = (value) => {
  if (value) {
    if (value.includes('primaryServicing')) {
      return 'PSA';
    }
    if (value.includes('primaryBilling')) {
      return 'PBA';
    }
    if (value.includes('primaryRemittance')) {
      return 'PRA';
    }
    if (value.includes('secondaryServicing[0]')) {
      return 'S1A';
    }
    if (value.includes('secondaryServicing[1]')) {
      return 'S2A';
    }
    if (value.includes('secondaryServicing[2]')) {
      return 'S3A';
    }
    if (value.includes('secondaryServicing[3]')) {
      return 'S4A';
    }
    if (value.includes('secondaryServicing[4]')) {
      return 'S5A';
    }
    if (value.includes('clia')) {
      return 'CMS';
    }
    if (value.includes('w9')) {
      return 'W9';
    }
  }
  return null;
};

export const getErrorFields = (error) => {
  const fields = {};
  if (!error.providerAttestCheckbox1) {
    fields.providerAttestCheckbox1 = '';
  }
  if (!error.providerAttestCheckbox2) {
    fields.providerAttestCheckbox2 = '';
  }
  if (!error.providerAttestCheckbox3) {
    fields.providerAttestCheckbox3 = '';
  }
  if (!error.providerAttestCheckbox4) {
    fields.providerAttestCheckbox4 = '';
  }
  if (!error.providerAttestCheckbox5) {
    fields.providerAttestCheckbox5 = '';
  }
  if (isEmpty(error.submitterName)) {
    fields.submitterName = '';
  }
  if (isEmpty(error.emailAddress)) {
    fields.emailAddress = '';
  }
  if (isEmpty(error.phoneNumber)) {
    fields.phoneNumber = '';
  }
  if (isEmpty(error.jobTitle)) {
    fields.jobTitle = '';
  }
  return fields;
};

export const clearForms = (form, clearStepTracker, setDocumentId, storage) => {
  form.reset();

  setDocumentId({ value: 'reset' });
  clearStepTracker();
  storage.local.remove('signature-type');
  storage.local.remove('signature-draw');
};
export const isCliaValid = (values) => {
  if (
    values.practiceTypeSelection &&
    CLIA_PRACTICES.includes(values.practiceTypeSelection)
  ) {
    if (
      (!values.cliaIdentification || values.cliaIdentification === '') &&
      !values.cliaFile &&
      !values.cliaAttestation
    ) {
      return true;
    }
    if (
      values.cliaIdentification &&
      !values.cliaFile &&
      !values.cliaAttestation
    ) {
      return true;
    }
    if (
      (!values.cliaIdentification || values.cliaIdentification === '') &&
      values.cliaFile &&
      !values.cliaAttestation
    ) {
      return true;
    }
    if (
      values.cliaIdentification &&
      values.cliaFile &&
      !values.cliaAttestation
    ) {
      return false;
    }
    return false;
  }
  return false;
};

export const getSessionRequestObj = (request) => {
  let w9Check = false;
  let pInfoCheck = false;
  let addrCheck = false;
  let attestCheck = false;

  if (request.w9Form && !isEmpty(request.w9Form)) {
    w9Check = true;
  }
  if (request.practiceInfo && !isEmpty(request.practiceInfo)) {
    pInfoCheck = true;
  }
  if (request.address && !isEmpty(request.address)) {
    addrCheck = true;
  }
  if (request.attestation && !isEmpty(request.attestation)) {
    attestCheck = true;
  }

  const w9Details = w9Check
    ? {
        name: request.w9Form.name || null,
        businessName: request.w9Form.businessName || null,
        federalTaxClassification:
          request.w9Form.federalTaxClassification &&
          !isEmpty(request.w9Form.federalTaxClassification)
            ? request.w9Form.federalTaxClassification
            : null,
        fileName: request.w9Form.fileName ? request.w9Form.fileName.name : null,
        doc360Id: request.documentIds['w9form.fileName'] || null,
      }
    : null;

  const practiceInfo = pInfoCheck ? request.practiceInfo : null;

  const isClia = CLIA_PRACTICES.includes(
    practiceInfo?.practiceTypeSelection
      ? practiceInfo.practiceTypeSelection
      : ''
  );
  const isAsc = practiceInfo?.practiceTypeSelection
    ? practiceInfo.practiceTypeSelection === 'Ambulatory Surgery Center'
    : false;

  const isRevoked = practiceInfo?.restrictionSelection
    ? practiceInfo.restrictionSelection === 'Yes'
    : false;

  const isNpiValid = practiceInfo?.isNpiValid;
  const licenses = request.practiceInfo ? request.practiceInfo.medLicense : [];
  const medLicense = [];

  if (licenses && licenses.length) {
    licenses.map((med) => {
      if (med.licenseType || med.licenseNumber) {
        medLicense.push({
          licenseType: med.licenseType,
          licenseNumber: med.licenseNumber,
          state: med.state ? med.state : '',
        });
        return true;
      }
      return false;
    });
  }

  const practiceInformation = practiceInfo
    ? {
        registrationType: practiceInfo.registrationTypeSelection || null,
        practiceType: practiceInfo.practiceTypeSelection
          ? practiceInfo.practiceTypeSelection
          : null,
        cliaId: isClia ? practiceInfo.cliaIdentification : null,
        medicareId: isAsc ? practiceInfo.medicareId : null,
        isRevoked,
        doc360IdCms: isClia
          ? request.documentIds['practiceInformation.cliaFile']
          : null,
        additionalDetails:
          practiceInfo.restrictionSelection === 'Yes'
            ? practiceInfo.restrictionInput || null
            : null,
        npi: [...practiceInfo.npiInformation.split(',')],

        fileName:
          isClia && practiceInfo.cliaFile ? practiceInfo.cliaFile.name : null,
        isNpiValid,
        licenses: medLicense,
      }
    : null;

  const primaryServicing = request.address?.primaryServicing;
  const primaryBilling = request.address?.primaryBilling;
  const primaryRemittance = request.address?.primaryRemittance;

  const address = addrCheck
    ? [
        {
          streetLine1: primaryServicing.streetLine1 || null,
          streetLine2: primaryServicing.streetLine2 || null,
          city: primaryServicing.city || null,
          state: primaryServicing.state ? primaryServicing.state : null,
          zipCode: primaryServicing.zipCode || null,
          type: 'PrimaryService',
          doc360Id: request.documentIds['address.primaryServicingProof'],
          fileName: request.address.primaryServicingProof
            ? request.address.primaryServicingProof.name
            : null,
        },
        {
          streetLine1: primaryBilling.streetLine1 || null,
          streetLine2: primaryBilling.streetLine2 || null,
          city: primaryBilling.city || null,
          state: primaryBilling.state ? primaryBilling.state : null,
          zipCode: primaryBilling.zipCode || null,
          type: 'PrimaryBilling',
          doc360Id: request.documentIds['address.primaryBillingProof'],
          fileName: request.address.primaryBillingProof
            ? request.address.primaryBillingProof.name
            : null,
        },
        {
          streetLine1: primaryRemittance.streetLine1 || null,
          streetLine2: primaryRemittance.streetLine2 || null,
          city: primaryRemittance.city || null,
          state: primaryRemittance.state ? primaryRemittance.state : null,
          zipCode: primaryRemittance.zipCode || null,
          type: 'PrimaryRemit',
          doc360Id: request.documentIds['address.primaryRemittanceProof'],
          fileName: request.address.primaryRemittanceProof
            ? request.address.primaryRemittanceProof.name
            : null,
        },
      ]
    : [];

  if (
    request.address &&
    request.address.secondaryServicing &&
    request.address.secondaryServicing[0] != null &&
    request.address.secondaryServicing.length > 0
  ) {
    const addressList = request.address.secondaryServicing;
    addressList.map((add, index) => {
      if (add) {
        address.push({
          streetLine1: add.streetLine1 || null,
          streetLine2: add.streetLine2 || null,
          city: add.city || null,
          state: add.state ? add.state : null,
          zipCode: add.zipCode || null,
          type: `SecondaryService${index + 1}`,
          doc360Id:
            request.documentIds[`address.secondaryServicing[${index}].proof`],
          fileName: add.proof ? add.proof.name : null,
        });
        return true;
      }

      return false;
    });
  }
  let claimDateCheck = null;

  if (request.attestation) {
    claimDateCheck = request.attestation.claimDate
      ? String(request.attestation.claimDate).replaceAll('/', '-')
      : request.attestation.claimDate;
  }

  const attestationDetails = attestCheck
    ? {
        name: request.attestation.submitterName || null,
        phoneNumber: request.attestation.phoneNumber || null,
        jobTitle: request.attestation.jobTitle
          ? request.attestation.jobTitle
          : null,
        email: request.attestation.emailAddress || null,
        communicationPreference: request.attestation.commPreference || null,
        claimDate:
          request.attestation.submitClaim === 'Yes' ? claimDateCheck : null,
        doc360Id:
          request.signatureType === 'Text'
            ? request.documentIds.textSignature
            : request.documentIds.drawSignature,
        isClaimSubmitted: request.attestation.submitClaim === 'Yes',
      }
    : {};
  return { w9Details, practiceInformation, address, attestationDetails };
};

export const checkSubmissionReady = (request) => {
  let submissionReady = false;
  if (request.signatureType === 'Text') {
    if (request.documentIds.textSignature) {
      submissionReady = true;
    }
  } else if (request.documentIds.drawSignature) {
    submissionReady = true;
  }
  return submissionReady;
};

export const generatePracticeListOptions = (options, practiceSel, sortBy) => {
  const moreOptions = [];
  let count = 0;
  options.forEach((element) => {
    if (element === practiceSel) {
      count += 1;
    }
    moreOptions.push({ label: element, value: element });
  });
  if (count < 1) {
    moreOptions.push({ label: practiceSel, value: practiceSel });
  }

  const opt = sortBy(moreOptions, (user) => {
    return user ? user.toLowerCase() : '';
  });

  if (!opt[0]) {
    opt.splice(0, 1);
  }

  return opt;
};
